import React from 'react';
import styled from '@emotion/styled';
import { useLoginOtp } from '../../toolympus/hooks/auth';
import { PublicPageWrapper } from '../Common/PublicPageWrapper';
import { Button, TextField, Typography } from '@mui/material';
import { Link } from '../../toolympus/components/primitives';

export const LoginOTP = () => {
    const data = useLoginOtp();
    
    return <PublicPageWrapper>
      
      <Typography variant="h2">Sign in</Typography>

      <LoginForm
        onSubmit={e => {
        e.preventDefault();
        data.save();
      }}>
        {!!data.item && <>
          <TextField
            type="email"
            value={data.item?.login}
            onChange={e => data.update({ login: e.target.value })}
            label="Email"
            disabled={!!data.item.isCode}
            autoFocus={!data.item.isCode}
            fullWidth
            />

          {data.item.isCode &&
            <Typography style={{ textAlign: "center" }}>
              Verification code has been sent to your email
              <br />
              <br />
            </Typography>}

          {data.item.isCode &&
            <TextField
              value={data.item?.code}
              onChange={e => data.update({ code: e.target.value })}
              label="Verification code"
              autoFocus
              fullWidth
              />}

          <Button
            color="primary"
            variant="contained"
            disabled={data.isLoading}
            type="submit"
            fullWidth
          >
            {data.item?.isCode ? "sign in" : "get the code"}
          </Button>
        </>}
      
        <Typography style={{ textAlign: "center" }}>or <Link to="/login">sign in</Link> with your password</Typography>
      </LoginForm>
      

    </PublicPageWrapper>;
}

const LoginForm = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.5rem;

  align-items: stretch;
  width: 300px;
`;